import AbstractRequestTask from '../AbstractRequestTask';

class RecordingsDeleteTask extends AbstractRequestTask {
  constructor(config, params) {
    super();
    this.params = params;
    this.config = config;
  }

  getUrl() {
    this.url = this.params.actions;
    return `${this.url}`;
  }

  getParams() {
    const params = super.getParams(this.config);
    this.params = Object.assign(params, this.params);
    const aux = Object.assign({}, this.params);
    if (aux.actions) delete aux.actions;
    return aux;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid) {
      return this.reject(data, b);
    }
    this.resolve(data);
  }

  error(err) {
    const json = (err && err.responseJSON) || JSON.parse(err.responseText);
    return this.resolve({ error: true, ...json });
  }

  getMethod() {
    return 'POST';
  }
}

export default RecordingsDeleteTask;
